// This file is autogenerated by scripts/generate-srcset.js
const resolveAsset = (module) => module && module.default ? module.default : module;

const manifest = {
  "all.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/all.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/all_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/all_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/all_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "banner.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/banner.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/banner_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/banner_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/banner_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "beforeribboncut.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/beforeribboncut.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/beforeribboncut_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/beforeribboncut_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/beforeribboncut_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "fAbeNcake.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/fAbeNcake.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/fAbeNcake_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/fAbeNcake_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/fAbeNcake_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "fatimaNcake.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/fatimaNcake.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/fatimaNcake_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/fatimaNcake_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/fatimaNcake_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "folajuNcake.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/folajuNcake.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/folajuNcake_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/folajuNcake_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/folajuNcake_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "friendsNcake.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/friendsNcake.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/friendsNcake_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/friendsNcake_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/friendsNcake_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "fummiNcake.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/fummiNcake.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/fummiNcake_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/fummiNcake_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/fummiNcake_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "grp1.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/grp1.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/grp1_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/grp1_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/grp1_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "grp2.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/grp2.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/grp2_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/grp2_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/grp2_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "ribboncuttin.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/ribboncuttin.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/ribboncuttin_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/ribboncuttin_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/ribboncuttin_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sam.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/sam.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/sam_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/sam_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/sam_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "seyi-report.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/seyi-report.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/seyi-report_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/seyi-report_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/seyi-report_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "srboiNgirl.jpeg": {
    src: resolveAsset(require('./reunion_photos/30yr/srboiNgirl.jpeg')),
    srcSet: `${resolveAsset(require("./reunion_photos/30yr/srboiNgirl_w320.jpeg"))} 320w, ${resolveAsset(require("./reunion_photos/30yr/srboiNgirl_w640.jpeg"))} 640w, ${resolveAsset(require("./reunion_photos/30yr/srboiNgirl_w1024.jpeg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "reunion21.jpg": {
    src: resolveAsset(require('./reunion_photos/reunion21.jpg')),
    srcSet: `${resolveAsset(require("./reunion_photos/reunion21_w320.jpg"))} 320w, ${resolveAsset(require("./reunion_photos/reunion21_w640.jpg"))} 640w, ${resolveAsset(require("./reunion_photos/reunion21_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "reunion22.jpg": {
    src: resolveAsset(require('./reunion_photos/reunion22.jpg')),
    srcSet: `${resolveAsset(require("./reunion_photos/reunion22_w320.jpg"))} 320w, ${resolveAsset(require("./reunion_photos/reunion22_w640.jpg"))} 640w, ${resolveAsset(require("./reunion_photos/reunion22_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "reunion222.jpg": {
    src: resolveAsset(require('./reunion_photos/reunion222.jpg')),
    srcSet: `${resolveAsset(require("./reunion_photos/reunion222_w320.jpg"))} 320w, ${resolveAsset(require("./reunion_photos/reunion222_w640.jpg"))} 640w, ${resolveAsset(require("./reunion_photos/reunion222_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "reunion23.jpg": {
    src: resolveAsset(require('./reunion_photos/reunion23.jpg')),
    srcSet: `${resolveAsset(require("./reunion_photos/reunion23_w320.jpg"))} 320w, ${resolveAsset(require("./reunion_photos/reunion23_w640.jpg"))} 640w, ${resolveAsset(require("./reunion_photos/reunion23_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "reunion232.jpg": {
    src: resolveAsset(require('./reunion_photos/reunion232.jpg')),
    srcSet: `${resolveAsset(require("./reunion_photos/reunion232_w320.jpg"))} 320w, ${resolveAsset(require("./reunion_photos/reunion232_w640.jpg"))} 640w, ${resolveAsset(require("./reunion_photos/reunion232_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch1.jpg": {
    src: resolveAsset(require('./project_photos/sch1.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch1_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch1_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch1_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch2.jpg": {
    src: resolveAsset(require('./project_photos/sch2.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch2_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch2_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch2_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch3.jpg": {
    src: resolveAsset(require('./project_photos/sch3.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch3_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch3_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch3_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch4.jpg": {
    src: resolveAsset(require('./project_photos/sch4.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch4_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch4_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch4_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch5.jpg": {
    src: resolveAsset(require('./project_photos/sch5.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch5_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch5_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch5_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch6.jpg": {
    src: resolveAsset(require('./project_photos/sch6.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch6_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch6_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch6_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch7.jpg": {
    src: resolveAsset(require('./project_photos/sch7.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch7_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch7_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch7_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
  "sch8.jpg": {
    src: resolveAsset(require('./project_photos/sch8.jpg')),
    srcSet: `${resolveAsset(require("./project_photos/sch8_w320.jpg"))} 320w, ${resolveAsset(require("./project_photos/sch8_w640.jpg"))} 640w, ${resolveAsset(require("./project_photos/sch8_w1024.jpg"))} 1024w`,
    sizes: "(max-width: 600px) 100vw, 600px",
  },
};
export default manifest;